module.exports = __webpack_public_path__ + "static/menu-illupino-min5-83a6c18874322034f5a639562fdb1c6f.jpg";